import { SET_RESERVATIONCOMPHISTORY } from '../actions';

const reservationcomplist = (state = [], action) => {
  switch (action.type) {
    case SET_RESERVATIONCOMPHISTORY:
      return [...action.value];
    default: return state;
  }
}

export default reservationcomplist;
